import { Box, Card, CircularProgress, Grid, InputLabel, Switch } from "@mui/material";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useState } from "react";
import { cleanFormatCNPJ, errorAlert, successAlert } from "utils/Functions";
import { get, postFile } from "utils/WebService";

export default function Tcd() {

    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const [cpf, setCPF] = useState();
    const [nome, setNome] = useState();
    const [profissao, setProfissao] = useState();
    const [pagamentoBancario, SetPagamentoBancario] = useState(false);
    const [pagamentoCredito, setPagamentoCredito] = useState(false);
    const [pagamentoDebito, setPagamentoDebito] = useState(false);
    const [pagamentoDeposito, setPagamentoDeposito] = useState(false);

    const [rg, setRg] = useState(false);
    const [isCpf, setIsCpf] = useState(false);
    const [comprovanteResidencia, setComprovanteResidencia] = useState(false);
    const [certidaoCasamento, setCertidaoCasamento] = useState(false);

    const [dataEnvio, setDataEnvio] = useState(null);
    const [isLoadingSearch, setIsLoadingSearch] = useState(false);
    const [isLoadingGerar, setIsLoadingGerar] = useState(false);
    const [isShow, setIsShow] = useState(false);
    const [errorProfissao, setErrorProfissao] = useState("");

    function findCPF(cpf) {
        setIsLoadingSearch(true)
        get(`/tcd/by-cpf/${cleanFormatCNPJ(cpf)}`)
            .then(data => {
                if (data != null) {
                    setIsShow(true)
                    setNome(data.ccAluno)
                } else setIsShow(false)

                setIsLoadingSearch(false)
            })
            .catch(error => {
                setIsLoadingSearch(false)
                setIsShow(false)
                errorAlert("Aluno não encontrado!")
            });
    }

    const handleSubmit = () => {
        setErrorProfissao("");
        if (!profissao) {
            setErrorProfissao("O campo profissão é obrigatório.");
            return;
        }

        setIsLoadingGerar(true)
        const body = {
            funcao: profissao,
            pagBoleto: pagamentoBancario,
            pagCC: pagamentoCredito,
            pagCB: pagamentoDebito,
            deposito: pagamentoDeposito,
            rg: rg,
            isCpf: isCpf,
            cpf: cpf,
            compResidencia: comprovanteResidencia,
            certCasamento: certidaoCasamento,
            dataEnvio: dataEnvio,
        };

        postFile("/tcd/generate", body, `TCD_UMC_${cpf}.pdf`)
            .then(() => {
                setIsLoadingGerar(false)
                successAlert("Arquivo gerado com sucesso!");
            })
            .catch(() => {
                setIsLoadingGerar(false)
                errorAlert("Erro ao processar o arquivo!")
            })
    };


    return (
        <Grid container display="flex" justifyContent="center">
            <Grid item xs={12} md={12}>
                <Card
                    variant="outlined"
                    sx={{
                        px: 2,
                        py: 1.5,
                        mb: 2,
                        background: darkMode ? "#23233a" : "#fafafa",
                        borderColor: darkMode ? "#333" : "#ddd",
                    }}
                >
                        <Grid container spacing={2} mb={2}>
                            <Grid item xs={12} sm={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>CPF</InputLabel>
                                <MDInput
                                    size="small"
                                    placeholder="Informe o CPF..."
                                    value={cpf}
                                    onChange={({ target }) => setCPF(target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12} sm={2} display="flex" alignItems="center">
                                <MDButton
                                    size="medium"
                                    sx={{ mt: 2 }}
                                    variant="contained"
                                    color="info"
                                    circular={false}
                                    iconOnly={false}
                                    onClick={() => {
                                        findCPF(cpf);
                                    }}
                                    endIcon={isLoadingSearch ?
                                        <CircularProgress
                                            color="inherit"
                                            size={20} sx={{ ml: 0, mr: 2 }} /> : null}>
                                    {!isLoadingSearch && "Buscar"}
                                </MDButton>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {isShow &&
                                    <>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Nome</InputLabel>
                                        <MDInput
                                            size="small"
                                            disabled={true}
                                            value={nome}
                                            onChange={({ target }) => setNome(target.value)}
                                            fullWidth
                                        />
                                    </>
                                }
                            </Grid>
                        </Grid>

                        <MDBox mb={1} mt={2}>
                            <MDTypography variant="h6" sx={{ fontSize: '14px' }}>Aluno</MDTypography>
                        </MDBox>
                        <Grid container spacing={2} mb={3}>
                            <Grid item xs={12} sm={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Profissão</InputLabel>
                                <MDInput
                                    size="small"
                                    required={true}
                                    placeholder="Informe a profissão..."
                                    value={profissao}
                                    onChange={({ target }) => {
                                        setProfissao(target.value);
                                        setErrorProfissao("");
                                    }}
                                    fullWidth
                                    error={!!errorProfissao}
                                    helperText={errorProfissao}
                                />
                            </Grid>
                        </Grid>

                        <MDBox mb={1} mt={2}>
                            <MDTypography variant="h6" sx={{ fontSize: '14px' }}>Formas de Pagamento</MDTypography>
                        </MDBox>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Box display="flex" alignItems="center" lineHeight={1.5}>
                                    <MDTypography variant="button" sx={{ fontSize: '10px' }}>
                                        Pagamento via Boleto Bancário
                                    </MDTypography>
                                    <Box ml={1}>
                                        <Switch checked={pagamentoBancario || false} onChange={(event) => SetPagamentoBancario(event.target.checked)} />
                                    </Box>
                                </Box>
                                <Box display="flex" alignItems="center" lineHeight={1.5}>
                                    <MDTypography variant="button" sx={{ fontSize: '10px' }}>
                                        Pagamento via Cartão de Crédito
                                    </MDTypography>
                                    <Box ml={1}>
                                        <Switch checked={pagamentoCredito || false} onChange={(event) => setPagamentoCredito(event.target.checked)} />
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box display="flex" alignItems="center" lineHeight={1.5}>
                                    <MDTypography variant="button" sx={{ fontSize: '10px' }}>
                                        Pagamento via Cartão de Débito
                                    </MDTypography>
                                    <Box ml={1}>
                                        <Switch checked={pagamentoDebito || false} onChange={(event) => setPagamentoDebito(event.target.checked)} />
                                    </Box>
                                </Box>
                                <Box display="flex" alignItems="center" lineHeight={1.5}>
                                    <MDTypography variant="button" sx={{ fontSize: '10px' }}>
                                        Pagamento via Depósito Bancário
                                    </MDTypography>
                                    <Box ml={1}>
                                        <Switch checked={pagamentoDeposito || false} onChange={(event) => setPagamentoDeposito(event.target.checked)} />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>

                        <MDBox mb={1} mt={3}>
                            <MDTypography variant="h6" sx={{ fontSize: '14px' }}>Documentação</MDTypography>
                        </MDBox>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Box display="flex" alignItems="center" lineHeight={1.5}>
                                    <MDTypography variant="button" sx={{ fontSize: '10px' }}>
                                        RG
                                    </MDTypography>
                                    <Box ml={1}>
                                        <Switch checked={rg || false} onChange={(event) => setRg(event.target.checked)} />
                                    </Box>
                                </Box>
                                <Box display="flex" alignItems="center" lineHeight={1.5}>
                                    <MDTypography variant="button" sx={{ fontSize: '10px' }}>
                                        CPF
                                    </MDTypography>
                                    <Box ml={1}>
                                        <Switch checked={isCpf || false} onChange={(event) => setIsCpf(event.target.checked)} />
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box display="flex" alignItems="center" lineHeight={1.5}>
                                    <MDTypography variant="button" sx={{ fontSize: '10px' }}>
                                        Comprovante de Residência
                                    </MDTypography>
                                    <Box ml={1}>
                                        <Switch checked={comprovanteResidencia || false} onChange={(event) => setComprovanteResidencia(event.target.checked)} />
                                    </Box>
                                </Box>
                                <Box display="flex" alignItems="center" lineHeight={1.5}>
                                    <MDTypography variant="button" sx={{ fontSize: '10px' }}>
                                        Certidão de Casamento
                                    </MDTypography>
                                    <Box ml={1}>
                                        <Switch checked={certidaoCasamento || false} onChange={(event) => setCertidaoCasamento(event.target.checked)} />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>

                        <MDBox mb={1} mt={3}>
                            <MDTypography variant="h6" sx={{ fontSize: '14px' }}>Formalização</MDTypography>
                        </MDBox>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Data Envio</InputLabel>
                                <MDTextFieldCalendar
                                    size="small"
                                    type="date"
                                    value={dataEnvio || ""}
                                    fullWidth
                                    onChange={({ target }) => setDataEnvio(target.value)}
                                    darkMode={darkMode}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} mt={4} display="flex" alignItems="center" justifyContent="center">
                            {isShow &&
                                <MDButton
                                    size="medium"
                                    sx={{ marginRight: 2 }}
                                    variant="contained"
                                    color="info"
                                    circular={false}
                                    iconOnly={false}
                                    onClick={() => {
                                        handleSubmit();
                                    }}
                                    endIcon={isLoadingGerar ?
                                        <CircularProgress
                                            color="inherit"
                                            size={20} sx={{ ml: 0, mr: 2 }} /> : null}>
                                    {!isLoadingGerar && "Gerar"}
                                </MDButton>
                            }
                        </Grid>
                    </Card>
            </Grid>
        </Grid >
    );
}

